import { Navigate, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Feature } from '@meeting-assistant/schemas';
import { TemplatesList } from '@/components/templates/TemplatesList';
import { useFlag } from '@/lib/features/FeatureProvider';
import { configQueryOptions } from '@/lib/query/configQuery';
export const Route = createFileRoute('/templates')({
  component: TemplatesRoute,
});
function TemplatesRoute() {
  const { isPending } = useQuery(configQueryOptions);
  const customTemplatesEditableEnabled = useFlag(
    Feature.CUSTOM_TEMPLATE_ENABLED,
  );
  if (isPending) {
    return null;
  }
  if (!customTemplatesEditableEnabled) {
    return <Navigate to="/" />;
  }
  return <TemplatesList />;
}
